const validMethods = [
  'readAsBinaryString',
  'readAsText',
  'readAsArrayBuffer',
  'readAsDataURL',
] as const;
type FileReaderMethod = (typeof validMethods)[number];

export const fileReader = (
  file: File | Blob,
  method: FileReaderMethod,
): Promise<string | ArrayBuffer | Error> => {
  if (!validMethods.includes(method))
    return Promise.reject(new Error('Invalid file reader method'));

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () =>
      resolve(
        method === 'readAsArrayBuffer' ? (reader.result as ArrayBuffer) : (reader.result as string),
      );
    reader.onerror = () => reject(new Error(reader.error?.message || 'Unknown FileReader error'));

    reader[method](file);
  });
};
